import type { SendMoneyLimitsState } from "../../types/sendMoney";

const KEY = "sendMoney.limits";

export const loadSendMoneyLimits = (): SendMoneyLimitsState | null => {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as SendMoneyLimitsState) : null;
  } catch {
    return null;
  }
};

export const saveSendMoneyLimits = (value: SendMoneyLimitsState): void => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    /* storage unavailable — non-fatal */
  }
};

export const clearSendMoneyLimits = (): void => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* non-fatal */
  }
};